import { ActionCreator } from 'redux';
import { Dispatch, ThunkAction } from '../../../../types/actions';
import { snackbarCardsUnarchived } from '../../snackbarsStack';
import { getMessages, root } from '../../../../store/constants';
import { SegmentArchiveEvent, segmentTrackAction } from '../../../../middlewares/segment';
import { listUnarchive } from '../../../../rest/effects/list/listUnarchive';

export const unarchiveAllCards: ActionCreator<ThunkAction> = (
    listId: number,
    boardId: number
) => {
    const action = (
        dispatch: Dispatch
    ) => {
        root.App.controller.mainView.renderBlockerModal({
            text: getMessages().getText('popup.list.unarchiving'),
            title: getMessages().getText('popup.list.unarchiving.header'),
        });

        return dispatch(listUnarchive(listId))
            .then(() => {
                root.App.vent.trigger(root.App.vent['aside-panel:hide']);
                root.App.vent.trigger(root.App.vent['dialog:closed']);
                dispatch(snackbarCardsUnarchived());
                dispatch(segmentTrackAction(SegmentArchiveEvent.UNARCHIVE_LIST));
                root.App.controller.mainView.removeBlockerModal()
            })
            .catch((err: any) => {
                root.App.vent.trigger(root.App.vent['aside-panel:hide']);
                root.App.vent.trigger(root.App.vent['dialog:closed']);
                root.App.controller.mainView.removeBlockerModal();
                return Promise.reject();
            })
    };
    return action;
};
